export default {
  Coupon: {
    Title   : 'Κουπόνια | Κουπόνι | Κουπόνια',
    ListView: {
      Button: {
        Add: {
          Title: 'Νέο Κουπόνι',
          Color: 'primary',
          Icon : 'add_box'
        },
        Edit: {
          Title: 'Επεξεργασία Κουπονιού',
          Color: 'cyan',
          Icon : 'edit'
        }
      },
      Table: {
        Headers: {
          Id              : '#',
          Name            : 'Όνομα',
          Code            : 'Κωδικός',
          Type            : 'Τύπος',
          Discount        : 'Έκπτωση',
          UsedCount       : 'Εξαργυρώσεις',
          Customers       : 'Πελάτες',
          CustomerGroups  : 'Ομάδες Πελατών',
          OrderRestriction: 'Τύπος Παραγγελίας',
          SourceType      : 'Πηγή Παραγγελίας',
          Validity        : 'Εγκυρότητα',
          AutoApply       : 'Αυτόματη Εφαρμογή',
          Status          : 'Κατάσταση',
          Actions         : ''
        }
      }
    },
    Dialog: {
      Toolbar: {
        Add: {
          Title   : 'Προσθήκη Κουπονιού',
          SubTitle: 'Δημιουργία Νέου Κουπονιού'
        },
        Edit: {
          Title   : 'Επεξεργασία Κουπονιού',
          SubTitle: 'Τροποποίηση Στοιχείων Κουπονιού'
        },
        Tab: {
          General     : 'Γενικά',
          Restrictions: 'Περιορισμοί',
          History     : 'Ιστορικό'
        }
      },

      History: {
        Table: {
          Headers: {
            Id        : '#',
            Customer  : 'Πελάτης',
            Order     : 'Παραγγελία',
            OrderTotal: 'Σύνολο',
            Amount    : 'Έκπτωση',
            Date      : 'Ημερομηνία'
          }
        }
      },

      Field: {

        Name: {
          Label: 'Όνομα',
          Hint : 'Όνομα Κουπονιού. πχ. Έκπτωση 10%',
          Error: {
            Between: 'Το όνομα πρέπει να είναι από 2 έως 128 χαρακτήρες'
          }
        },
        Code: {
          Label: 'Κωδικός',
          Hint : 'Κωδικός Κουπονιού. πχ. OFFER10, κλπ.',
          Error: {
            Between: 'Ο κωδικός πρέπει να είναι από 2 έως 15 χαρακτήρες'
          }
        },

        Type: {
          Title      : 'Τύπος Έκπτωσης',
          RadioOption: {
            DiscountPercent: 'Ποσοστό Έκπτωσης',
            FixedPrice     : 'Καθορισμένη Τιμή'
          }

        },

        Discount: {
          Label: {
            DiscountPercent: '@:Marketing.Coupon.Dialog.Field.Type.RadioOption.DiscountPercent',
            FixedPrice     : '@:Marketing.Coupon.Dialog.Field.Type.RadioOption.FixedPrice'
          },
          Hint : '@:Marketing.Coupon.Dialog.Field.Discount.Label.DiscountPercent ή @:Marketing.Coupon.Dialog.Field.Discount.Label.FixedPrice έκπτωσης',
          Error: {
            Number: 'Πρέπει να είναι αριθμός'
          }
        },

        OrderRestriction: {
          Title      : 'Τύπος Παραγγελίας',
          RadioOption: {
            All     : 'Όλες',
            Delivery: 'Παράδοση',
            TakeAway: 'Παραλαβή'
          }
        },

        Redemptions: {
          Label: 'Εξαργυρώσεις',
          Hint : 'Ο συνολικός αριθμός των φορών που αυτό το κουπόνι μπορεί να εξαργυρωθεί. Εισάγετε 0 για απεριόριστες εξαργυρώσεις.',
          Error: {
            Number: '@:Marketing.Coupon.Dialog.Field.Discount.Error.Number'
          }
        },

        CustomerRedemptions: {
          Label: 'Εξαργυρώσεις Πελάτη',
          Hint : 'Ο συνολικός αριθμός των φορών που αυτό το κουπόνι μπορεί να εξαργυρωθεί ανά πελάτη. Εισάγετε 0 για απεριόριστες εξαργυρώσεις.',
          Error: {
            Number: '@:Marketing.Coupon.Dialog.Field.Discount.Error.Number'
          }
        },

        MinTotal: {
          Label: 'Ελάχιστο σύνολο',
          Hint : 'Ελάχιστο σύνολο παραγγελίας για να μπορεί να χρησιμοποιηθεί το κουπόνι',
          Error: {
            Number: '@:Marketing.Coupon.Dialog.Field.Discount.Error.Number'
          }
        },

        Status: {
          Title: 'Κατάσταση'
        },

        AutoApply: {
          Title: 'Αυτόματη Εφαρμογή'
        },

        Validity: {
          Title : 'Εγκυρότητα',
          Toggle: {
            Always: {
              Title: 'Πάντα'
            },
            DateTime: {
              Title  : 'Ημερομηνία / Ώρα',
              Options: {
                TwentyFourHours: '24 Ώρες',
                Custom         : 'Προσαρμοσμενο'
              }
            },
            Period: {
              Title: 'Περίοδος'
            },
            Repeat: {
              Title  : 'Επαναληψη',
              Options: {
                TwentyFourHours: '@:Marketing.Coupon.Dialog.Field.Validity.Toggle.DateTime.Options.TwentyFourHours',
                Custom         : '@:Marketing.Coupon.Dialog.Field.Validity.Toggle.DateTime.Options.Custom'
              }
            }
          }
        }

      },

      Message: {
        Save: {
          Success: 'Το κουπόνι αποθηκεύτηκε επιτυχώς.'
        },
        Update: {
          Success: 'Το κουπόνι ενημερώθηκε επιτυχώς.'
        }
      }
    }
  },

  Tag: {
    Title   : 'Ετικέτες Marketing | Ετικέτα Marketing | Ετικέτες Marketing',
    ListView: {
      Button: {
        Add: {
          Title: 'Νέα Ετικέτα Marketing',
          Color: 'primary',
          Icon : 'add_box'
        },
        Edit: {
          Title: 'Επεξεργασία Ετικέτα Marketing',
          Color: 'cyan',
          Icon : 'edit'
        },
        Delete: {
          Title: 'Διαγραφή Ετικέτα Marketing',
          Color: 'red',
          Icon : 'close'
        }
      },
      Table: {
        Headers: {
          Id       : '#',
          Name     : 'Όνομα',
          CreatedAt: 'Ημ/νία',
          Actions  : ''
        },
        NoData: {
          Icon     : 'mdi-email-fast-outline',
          IconColor: 'light-blue lighten-3',
          Title    : 'Marketing Tags',
          Subtitle : '',
          Button   : {
            Title: 'Νέα Ετικέτα Marketing',
            Color: 'primary',
            Icon : 'add_box'
          },
          Bullets: {
            Icon     : 'mdi-check-circle',
            IconColor: 'blue',
            Items    : []
          }
        }
      },
      ConfirmDeleteDialog: {
        Title  : 'Διαγραφή Ετικέτας Marketing;',
        Content: 'Είστε σίγουροι ότι θέλετε να διαγράψετε την ετικέτα marketing "<span class="font-weight-light font-italic">{title}</span>";',
        Warning: 'Η διαγραφή είναι οριστική και η διαδικασία είναι μη αναστρέψιμη'
      }
    },
    Dialog: {
      EditTag: {
        Toolbar: {
          Add: {
            Title   : 'Ετικέτα Marketing',
            SubTitle: 'Δημιουργία',
            Icon    : 'mdi-tag-text-outline'
          },
          Edit: {
            Title   : 'Ετικέτα Marketing',
            SubTitle: 'Επεξεργασία',
            Icon    : 'mdi-tag-text-outline'
          }
        },
        Message: {
          Save: {
            Success: 'Η ετικέτα marketing αποθηκεύτηκε επιτυχώς.'
          },
          delete: {
            Success: 'Η ετικέτα marketing διαγράφηκε επιτυχώς.'
          }
        },
        Field: {
          Name: {
            Label: 'Όνομα',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'Πρέπει να συμπληρώσετε όνομα',
              Between : 'Το όνομα πρέπει να είναι από 2 έως 128 χαρακτήρες'
            }
          }
        }
      }
    }
  },

  Email: {
    Title   : 'Καμπάνιες Email | Καμπάνια Email | Καμπάνιες Email',
    ListView: {
      Button: {
        ViewTemplate: {
          Title: 'Πρότυπα Email',
          Color: 'primary',
          Icon : 'mdi-view-compact-outline'
        },
        Add: {
          Title: 'Νέα Καμπάνια Email',
          Color: 'primary',
          Icon : 'add_box'
        },
        Edit: {
          Title: 'Επεξεργασία Καμπάνιας Email',
          Color: 'cyan',
          Icon : 'edit'
        },
        Duplicate: {
          Title: 'Αντιγραφή Καμπάνιας Email',
          Color: 'orange',
          Icon : 'mdi-content-copy'
        },
        Delete: {
          Title: 'Διαγραφή Καμπάνιας Email',
          Color: 'red',
          Icon : 'close'
        }
      },
      Table: {
        Headers: {
          Id         : '#',
          Name       : 'Όνομα',
          Groups     : 'Ομάδες',
          Tags       : 'Ετικέτες',
          Status     : 'Κατάσταση',
          Sent       : 'Απεσταλμένα',
          Delivered  : 'Παραδομένα',
          Opened     : 'Opened',
          Clicked    : 'Clicked',
          SendAt     : 'Ημ/νία Αποστολής',
          ScheduledAt: 'Ημ/νία Προγραμ/νη',
          CreatedAt  : 'Ημ/νία Δημιουργίας',
          Actions    : ''
        },
        NoData: {
          Icon     : 'mdi-email-fast-outline',
          IconColor: 'light-blue lighten-3',
          Title    : 'Καμπάνιες Email',
          Subtitle : '',
          Button   : {
            Title: 'Νέα Καμπάνια',
            Color: 'primary',
            Icon : 'add_box'
          },
          Bullets: {
            Icon     : 'mdi-check-circle',
            IconColor: 'blue',
            Items    : [
              'Διαχείριση email μάρκετινγκ εύκολα και γρήγορα',
              'Επεξεργασία χωρίς κώδικα για εύκολη δημιουργία',
              'Email για ενημέρωση, κουπόνια, προσφορές και άλλα'
            ]
          }
        }
      },
      ConfirmDeleteDialog: {
        Title  : 'Διαγραφή Καμπάνιας;',
        Content: 'Είστε σίγουροι ότι θέλετε να διαγράψετε την καμπάνια "<span class="font-weight-light font-italic">{title}</span>";',
        Warning: 'Η διαγραφή είναι οριστική και η διαδικασία είναι μη αναστρέψιμη'
      }
    },
    Dialog: {
      EditCampaign: {
        Toolbar: {
          Title   : 'Καμπάνια Email',
          SubTitle: 'Επεξεργασία',
          Icon    : 'mdi-email-fast'
        },
        Message: {
          Save: {
            Success: 'Η καμπάνια αποθηκεύτηκε επιτυχώς.'
          },
          Send: {
            Success: 'Η καμπάνια στάλθηκε επιτυχώς.'
          }
        },
        ConfirmSend: {
          Title  : 'Αποστολή Καμπάνιας;',
          Content: 'Είστε σίγουροι ότι θέλετε να στείλετε την καμπάνια;'
        },
        Section: {
          Audience: '1. Αποδέκτες',
          Sender  : '2. Αποστολέας',
          Message : '3. Μήνυμα',
          Delivery: '4. Αποστολή'
        },
        Field: {
          Name: {
            Label: 'Όνομα',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'Πρέπει να συμπληρώσετε όνομα',
              Between : 'Το όνομα πρέπει να είναι από 2 έως 128 χαρακτήρες'
            }
          },
          Subject: {
            Label: 'Θέμα',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'Πρέπει να συμπληρώσετε θέμα',
              Between : 'Το θέμα πρέπει να είναι από 2 έως 128 χαρακτήρες'
            }
          },
          Tag: {
            Label: 'Ετικέτες',
            Hint : '',
            Icon : ''
          },
          GroupIncludes: {
            Label: 'Include Customer Group',
            Hint : '',
            Icon : ''
          },
          GroupExcludes: {
            Label: 'Exclude Customer Group',
            Hint : '',
            Icon : ''
          },
          SenderName: {
            Label: 'Όνομα Αποστολέα',
            Hint : '',
            Icon : ''
          },
          SenderEmail: {
            Label: 'Email Αποστολέα',
            Hint : '',
            Icon : ''
          },
          ScheduledAt: {
            LabelNow      : 'Άμεσα',
            LabelScheduled: 'Μελλοντικά',
            Hint          : '',
            Icon          : '',
            Error         : {
              RequiredDate: 'Πρέπει να επιλέξετε ημερομηνία',
              RequiredTime: 'Πρέπει να επιλέξετε ώρα'
            }
          }
        }
      },
      AddCampaign: {
        Toolbar: {
          Title   : 'Καμπάνια Email',
          SubTitle: 'Δημιουργία',
          Icon    : 'mdi-email-fast'
        }
      },
      PreviewTemplate: {
        Toolbar: {
          Title   : 'Πρότυπο Email',
          SubTitle: 'Προεπισκόπηση',
          Icon    : 'mdi-email-newsletter'
        }
      },
      EditTemplate: {
        Toolbar: {
          Title   : 'Πρότυπο Email',
          SubTitle: 'Επεξεργασία',
          Icon    : 'mdi-email-newsletter'
        },
        Message: {
          Save: {
            Success: 'Το πρότυπο αποθηκεύτηκε επιτυχώς.'
          }
        },
        Field: {
          Title: {
            Label: 'Όνομα',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'Πρέπει να συμπληρώσετε όνομα',
              Between : 'Το όνομα πρέπει να είναι από 2 έως 128 χαρακτήρες'
            }
          },
          Subject: {
            Label: 'Θέμα',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'Πρέπει να συμπληρώσετε θέμα',
              Between : 'Το θέμα πρέπει να είναι από 2 έως 256 χαρακτήρες'
            }
          }
        }
      },
      AddTemplate: {
        Toolbar: {
          Title   : 'Πρότυπο Email',
          SubTitle: 'Δημιουργία',
          Icon    : 'mdi-email-newsletter'
        }
      },
      Templates: {
        Toolbar: {
          Title   : 'Πρότυπα Email',
          SubTitle: 'Επιλέξτε πρότυπο Email',
          Icon    : 'mdi-email-newsletter'
        },
        Button: {
          New: {
            Title: 'Νέο Πρότυπο',
            Color: 'green',
            Icon : 'mdi-application-edit-outline'
          },
          Edit: {
            Title: 'Επεξεργασία Προτύπου',
            Color: 'blue',
            Icon : 'mdi-application-cog-outline'
          },
          Preview: {
            Title: 'Προβολή Προτύπου',
            Color: 'blue-grey',
            Icon : 'mdi-file-find'
          },
          Select: {
            Title: 'Επιλογή Προτύπου',
            Color: 'green',
            Icon : 'mdi-file-code-outline'
          },
          Delete: {
            Title: 'Διαγραφή Προτύπου',
            Color: 'red',
            Icon : 'mdi-close-circle-outline'
          }
        },
        Blank: {
          Title  : 'Κενό Πρότυπο',
          Subject: 'Ξεκινήστε με ένα κενό πρότυπο'
        },
        NoDataEdit: {
          Icon     : 'mdi-email-newsletter',
          IconColor: 'light-blue lighten-3',
          Title    : 'Πρότυπα Email',
          Subtitle : 'Δεν υπάρχουν ακόμη πρότυπα Email',
          Button   : {
            Title: 'Νέο Πρότυπο',
            Color: 'primary',
            Icon : 'add_box'
          }
        },
        NoDataSelect: {
          Icon     : 'mdi-email-newsletter',
          IconColor: 'light-blue lighten-3',
          Title    : 'Πρότυπα Email',
          Subtitle : 'Δεν υπάρχουν ακόμη πρότυπα Email',
          Button   : {
            Title: 'Νέο Πρότυπο',
            Color: 'primary',
            Icon : 'add_box',
            Block: true
          },
          ButtonCampaign: {
            Title: 'Νέα Καμπάνια Χωρίς Πρότυπο',
            Color: 'green',
            Icon : 'add_box'
          }
        }
      }
    }
  },

  Sms: {
    Title   : 'Καμπάνιες SMS | Καμπάνια SMS | Καμπάνιες SMS',
    ListView: {
      Button: {
        ViewTemplate: {
          Title: 'Πρότυπα SMS',
          Color: 'primary',
          Icon : 'mdi-view-compact-outline'
        },
        Add: {
          Title: 'Νέα Καμπάνια SMS',
          Color: 'primary',
          Icon : 'add_box'
        },
        Edit: {
          Title: 'Επεξεργασία Καμπάνιας SMS',
          Color: 'cyan',
          Icon : 'edit'
        },
        Duplicate: {
          Title: 'Αντιγραφή Καμπάνιας SMS',
          Color: 'orange',
          Icon : 'mdi-content-copy'
        },
        Delete: {
          Title: 'Διαγραφή Καμπάνιας SMS',
          Color: 'red',
          Icon : 'close'
        }
      },
      Table: {
        Headers: {
          Id         : '#',
          Name       : 'Όνομα',
          Groups     : 'Ομάδες',
          Tags       : 'Ετικέτες',
          Status     : 'Κατάσταση',
          Sent       : 'Απεσταλμένα',
          Delivered  : 'Παραδομένα',
          Opened     : 'Opened',
          Clicked    : 'Clicked',
          SendAt     : 'Ημ/νία Αποστολής',
          ScheduledAt: 'Ημ/νία Προγραμ/νη',
          CreatedAt  : 'Ημ/νία Δημιουργίας',
          Actions    : ''
        },
        NoData: {
          Icon     : 'mdi-message-fast-outline',
          IconColor: 'light-blue lighten-3',
          Title    : 'Καμπάνιες SMS',
          Subtitle : '',
          Button   : {
            Title: 'Νέα Καμπάνια',
            Color: 'primary',
            Icon : 'add_box'
          },
          ButtonActivate: {
            Title: 'Ενεργοποίηση',
            Color: 'primary',
            Icon : 'add_box'
          },
          Bullets: {
            Icon     : 'mdi-check-circle',
            IconColor: 'blue',
            Items    : [
              'Διαχείριση SMS μάρκετινγκ εύκολα και γρήγορα',
              'Επεξεργασία χωρίς κώδικα για εύκολη δημιουργία',
              'SMS για ενημέρωση, κουπόνια, προσφορές και άλλα'
            ]
          }
        }
      },
      ConfirmDeleteDialog: {
        Title  : 'Διαγραφή Καμπάνιας;',
        Content: 'Είστε σίγουροι ότι θέλετε να διαγράψετε την καμπάνια "<span class="font-weight-light font-italic">{title}</span>";',
        Warning: 'Η διαγραφή είναι οριστική και η διαδικασία είναι μη αναστρέψιμη'
      }
    },
    Dialog: {
      EditCampaign: {
        Toolbar: {
          Title   : 'Καμπάνια SMS',
          SubTitle: 'Επεξεργασία',
          Icon    : 'mdi-email-fast'
        },
        Message: {
          Save: {
            Success: 'Η καμπάνια αποθηκεύτηκε επιτυχώς.'
          },
          Send: {
            Success: 'Η καμπάνια στάλθηκε επιτυχώς.'
          }
        },
        ConfirmSend: {
          Title  : 'Αποστολή Καμπάνιας;',
          Content: 'Είστε σίγουροι ότι θέλετε να στείλετε την καμπάνια;'
        },
        Section: {
          Audience: '1. Αποδέκτες',
          Sender  : '2. Αποστολέας',
          Message : '3. Μήνυμα',
          Delivery: '4. Αποστολή'
        },
        Field: {
          Name: {
            Label: 'Όνομα',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'Πρέπει να συμπληρώσετε όνομα',
              Between : 'Το όνομα πρέπει να είναι από 2 έως 128 χαρακτήρες'
            }
          },
          Body: {
            Label: 'Μήνυμα',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'Πρέπει να συμπληρώσετε το μήνυμα'
            }
          },
          Tag: {
            Label: 'Ετικέτες',
            Hint : '',
            Icon : ''
          },
          GroupIncludes: {
            Label: 'Include Customer Group',
            Hint : '',
            Icon : ''
          },
          GroupExcludes: {
            Label: 'Exclude Customer Group',
            Hint : '',
            Icon : ''
          },
          SenderName: {
            Label: 'Όνομα Αποστολέα',
            Hint : '',
            Icon : ''
          },
          ScheduledAt: {
            LabelNow      : 'Άμεσα',
            LabelScheduled: 'Μελλοντικά',
            Hint          : '',
            Icon          : '',
            Error         : {
              RequiredDate: 'Πρέπει να επιλέξετε ημερομηνία',
              RequiredTime: 'Πρέπει να επιλέξετε ώρα'
            }
          },
          RespectQuietHours: {
            Label  : 'Εκτός ωρών κοινής ησυχίας',
            Tooltip: 'Αν η αποστολή πρέπει να σέβεται τις ώρες κοινής ησυχίας. Οι ώρες κοινής ησυχίας καθορίζονται από προεπιλογή στις 23.00 - 08.00 και 14.00 - 17.00 τοπική ώρα προορισμού.'
          },
          Info: {
            Sms       : 'SMS',
            Characters: 'Χαρακτήρες | Χαρακτήρας | Χαρακτήρες',
            Encoding  : 'Κωδικοποίηση'
          }
        }
      },
      AddCampaign: {
        Toolbar: {
          Title   : 'Καμπάνια SMS',
          SubTitle: 'Δημιουργία',
          Icon    : 'mdi-email-fast'
        }
      },
      PreviewTemplate: {
        Toolbar: {
          Title   : 'Πρότυπο SMS',
          SubTitle: 'Προεπισκόπηση',
          Icon    : 'mdi-email-newsletter'
        }
      },
      EditTemplate: {
        Toolbar: {
          Title   : 'Πρότυπο SMS',
          SubTitle: 'Επεξεργασία',
          Icon    : 'mdi-email-newsletter'
        },
        Message: {
          Save: {
            Success: 'Το πρότυπο αποθηκεύτηκε επιτυχώς.'
          }
        },
        Field: {
          Title: {
            Label: 'Όνομα',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'Πρέπει να συμπληρώσετε όνομα',
              Between : 'Το όνομα πρέπει να είναι από 2 έως 128 χαρακτήρες'
            }
          },
          Body: {
            Label: 'Μήνυμα',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'Πρέπει να συμπληρώσετε το μήνυμα',
              Between : 'Το μήνυμα πρέπει να είναι από 2 έως 160 χαρακτήρες'
            }
          }
        }
      },
      AddTemplate: {
        Toolbar: {
          Title   : 'Πρότυπο SMS',
          SubTitle: 'Δημιουργία',
          Icon    : 'mdi-email-newsletter'
        }
      },
      Templates: {
        Toolbar: {
          Title   : 'Πρότυπα SMS',
          SubTitle: 'Επιλέξτε πρότυπο SMS',
          Icon    : 'mdi-email-newsletter'
        },
        Button: {
          New: {
            Title: 'Νέο Πρότυπο',
            Color: 'green',
            Icon : 'mdi-application-edit-outline'
          },
          Edit: {
            Title: 'Επεξεργασία Προτύπου',
            Color: 'blue',
            Icon : 'mdi-application-cog-outline'
          },
          Preview: {
            Title: 'Προβολή Προτύπου',
            Color: 'blue-grey',
            Icon : 'mdi-file-find'
          },
          Select: {
            Title: 'Επιλογή Προτύπου',
            Color: 'green',
            Icon : 'mdi-file-code-outline'
          },
          Delete: {
            Title: 'Διαγραφή Προτύπου',
            Color: 'red',
            Icon : 'mdi-close-circle-outline'
          }
        },
        Blank: {
          Title  : 'Κενό Πρότυπο',
          Subject: 'Ξεκινήστε με ένα κενό πρότυπο'
        },
        NoDataEdit: {
          Icon     : 'mdi-email-newsletter',
          IconColor: 'light-blue lighten-3',
          Title    : 'Πρότυπα SMS',
          Subtitle : 'Δεν υπάρχουν ακόμη πρότυπα SMS',
          Button   : {
            Title: 'Νέο Πρότυπο',
            Color: 'primary',
            Icon : 'add_box'
          }
        },
        NoDataSelect: {
          Icon     : 'mdi-email-newsletter',
          IconColor: 'light-blue lighten-3',
          Title    : 'Πρότυπα SMS',
          Subtitle : 'Δεν υπάρχουν ακόμη πρότυπα SMS',
          Button   : {
            Title: 'Νέο Πρότυπο',
            Color: 'primary',
            Icon : 'add_box',
            Block: true
          },
          ButtonCampaign: {
            Title: 'Νέα Καμπάνια Χωρίς Πρότυπο',
            Color: 'green',
            Icon : 'add_box'
          }
        }
      }
    }
  },

  Push: {
    Title   : 'Καμπάνιες Push Notification | Καμπάνια Push Notification | Καμπάνιες Push Notification',
    ListView: {
      Button: {
        Add: {
          Title: 'Νέα Καμπάνια Push Notification',
          Color: 'primary',
          Icon : 'add_box'
        },
        Edit: {
          Title: 'Επεξεργασία Καμπάνιας Push Notification',
          Color: 'cyan',
          Icon : 'edit'
        }
      },
      Table: {
        Headers: {
          Id       : '#',
          Name     : 'Όνομα',
          Groups   : 'Ομάδες',
          Status   : 'Κατάσταση',
          Total    : 'Σύνολο',
          Delivered: 'Παραδομένα',
          Ctr      : 'CTR',
          SendAt   : 'Ημ/νία Αποστολής',
          CreatedAt: 'Ημ/νία Δημιουργίας',
          Actions  : ''
        },
        NoData: {
          Icon     : 'mdi-bell-badge-outline',
          IconColor: 'light-blue lighten-3',
          Title    : 'Καμπάνιες Push Notification',
          Subtitle : '',
          Button   : {
            Title: 'Νέα Καμπάνια',
            Color: 'primary',
            Icon : 'add_box'
          },
          Bullets: {
            Icon     : 'mdi-check-circle',
            IconColor: 'blue',
            Items    : [
              'Διαχείριση Push Notification μάρκετινγκ εύκολα και γρήγορα',
              'Επεξεργασία χωρίς κώδικα για εύκολη δημιουργία',
              'Push Notification για ενημέρωση, κουπόνια, προσφορές και άλλα'
            ]
          }
        }
      }
    }
  },

  Print: {
    Title   : 'Πρότυπα Εκτυπώσεων | Πρότυπο Εκτυπώσεων | Πρότυπα Εκτυπώσεων',
    ListView: {
      Button: {
        Add: {
          Title: 'Νέο Πρότυπο',
          Color: 'green',
          Icon : 'mdi-application-edit-outline'
        },
        Edit: {
          Title: 'Επεξεργασία Προτύπου',
          Color: 'blue',
          Icon : 'mdi-application-cog-outline'
        },
        Duplicate: {
          Title: 'Αντιγραφή Προτύπου',
          Color: 'orange',
          Icon : 'mdi-content-copy'
        },
        Preview: {
          Title: 'Προβολή Προτύπου',
          Color: 'blue-grey',
          Icon : 'mdi-file-find'
        },
        Delete: {
          Title: 'Διαγραφή Προτύπου',
          Color: 'red',
          Icon : 'mdi-close-circle-outline'
        }
      },
      Tab: {
        Tab1: 'Πρότυπο',
        Tab2: 'Δυναμικά Πεδία'
      },
      Table: {
        Headers: {
          Id       : '#',
          Name     : 'Όνομα',
          Products : 'Προϊόντα',
          CreatedAt: 'Ημ/νία',
          Actions  : ''
        },
        NoData: {
          Icon     : 'mdi-tray-full',
          IconColor: 'light-blue lighten-3',
          Title    : 'Πρότυπα Εκτυπώσεων',
          Subtitle : '',
          Button   : {
            Title: 'Νέο Πρότυπο',
            Color: 'primary',
            Icon : 'add_box'
          },
          Bullets: {
            Icon     : 'mdi-check-circle',
            IconColor: 'blue',
            Items    : []
          }
        }
      },
      ConfirmDeleteDialog: {
        Title  : 'Διαγραφή Προτύπου;',
        Content: 'Είστε σίγουροι ότι θέλετε να διαγράψετε το πρότυπο "<span class="font-weight-light font-italic">{title}</span>";',
        Warning: 'Η διαγραφή είναι οριστική και η διαδικασία είναι μη αναστρέψιμη'
      }
    },
    Dialog: {
      PreviewTemplate: {
        Toolbar: {
          Title   : 'Πρότυπο',
          SubTitle: 'Προεπισκόπηση',
          Icon    : 'mdi-email-newsletter'
        }
      },
      EditTemplate: {
        Toolbar: {
          Title   : 'Πρότυπο',
          SubTitle: 'Επεξεργασία',
          Icon    : 'mdi-email-newsletter'
        },
        Message: {
          Save: {
            Success: 'Το πρότυπο αποθηκεύτηκε επιτυχώς.'
          }
        },
        Field: {
          Title: {
            Label: 'Όνομα',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'Πρέπει να συμπληρώσετε όνομα',
              Between : 'Το όνομα πρέπει να είναι από 2 έως 128 χαρακτήρες'
            }
          }
        }
      },
      AddTemplate: {
        Toolbar: {
          Title   : 'Πρότυπο',
          SubTitle: 'Δημιουργία',
          Icon    : 'mdi-email-newsletter'
        }
      }
    }
  },

  Campaign: {
    Status: {
      UNKNOWN: {
        Id   : 'UNKNOWN',
        Name : 'UNKNOWN',
        Color: 'grey'
      },
      QUEUED: {
        Id   : 'QUEUED',
        Name : 'QUEUED',
        Color: 'amber'
      },
      DRAFT: {
        Id   : 'DRAFT',
        Name : 'DRAFT',
        Color: 'blue-grey'
      },
      SCHEDULED: {
        Id   : 'SCHEDULED',
        Name : 'SCHEDULED',
        Color: 'indigo'
      },
      DELIVERED: {
        Id   : 'DELIVERED',
        Name : 'DELIVERED',
        Color: 'green'
      },
      SENT: {
        Id   : 'SENT',
        Name : 'SENT',
        Color: 'light-green'
      }
    }
  }
}
